import Swal from "sweetalert2";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
// import "./LoginStyle.css";
import { postLoginToken2, getRoles } from "../../3.Store/LoginSlice";

const LoginMobile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get token2 and location from URL parameters
  const { token2, location } = useParams();

  const user = JSON.parse(localStorage.getItem('user'));
  const username = user?.fullname;
  const id = user?.id;

  const allowedRoutes = [
    "LeaveApprovalList",
    "LeaveApplicationList"
  ];
  
  const home = "/";

  useEffect(() => {   
    dispatch(postLoginToken2({token2})) // Call postLoginToken2
      .unwrap()
      .then((data) => {
        console.log(data);
        const entity = { username, id };
        dispatch(getRoles(entity)) // Fetch user roles if needed
        .unwrap()
        .then(() => {
          // navigate(`/${location}`);
          // window.location.reload();
          const target = allowedRoutes.includes(location)
            ? `/${location}`
            : home;

          navigate(target, { replace: true });
        })
      })
      .catch((error) => {
        // Swal.fire("Error / Masalah", err.response.data, "error", "OK");
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Something went wrong!",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/login"); // Redirect after clicking OK
        });
      });
  }, []);

  return (
    <Container className="ContainerContent"></Container>
  );
};

export default LoginMobile;